<template>
<div class="payment-selector">
    <div class="radio-container">
        <div class="mdc-form-field">
            <div class="mdc-radio">
                <input class="mdc-radio__native-control" type="radio" id="radio-1" name="radios" checked value="card" v-model="radio" @change="handleInput">
                <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
                </div>
                <div class="mdc-radio__ripple"></div>
            </div>
            <label for="radio-1">{{$trans.get('wizard.step4.card-title')}}</label>
        </div>
        <div class="mt-3">
            <p>{{$trans.get('wizard.step4.card-description')}}</p>
        </div>
    </div>
    <hr class="hr-black">
    <div class="radio-container">
        <div class="mdc-form-field">
            <div class="mdc-radio">
                <input class="mdc-radio__native-control" type="radio" id="radio-2" name="radios" value="transfer" v-model="radio" @change="handleInput">
                <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
                </div>
                <div class="mdc-radio__ripple"></div>
            </div>
            <label for="radio-2">{{$trans.get('wizard.step4.transfer-title')}}</label>
        </div>
        <transition name="fade">
            <div v-if="radio == 'transfer'" class="mt-3">
                <p>{{$trans.get('wizard.step4.transfer-description')}}</p>
                <div class="my-8">
                    <p class="font-bold">{{$trans.get('wizard.step4.bank')}}<span class="font-normal"> BBVA Banco Bilbao Vizcaya Argentaria</span></p>
                    <p class="font-bold">{{$trans.get('wizard.step4.transfer-name')}}<span class="font-normal"> Escola de Formació Professional Ramón i Cajal</span></p>
                    <p class="font-bold">{{ $trans.get('wizard.step4.transfer-number') }}<span class="font-normal"> IBAN ES10 0182 6319 9902 0008 0717</span></p>
                    <p class="font-bold">BIC:<span class="font-normal"> BBVAESMM</span> </p>
                </div>
                <div>
                    <p class="font-bold">{{$trans.get('wizard.step4.bank')}}<span class="font-normal"> Caixa Bank</span></p>  
                    <p class="font-bold">{{$trans.get('wizard.step4.transfer-name')}}<span class="font-normal"> Escola de Formació Professional Ramón i Cajal</span></p>
                    <p class="font-bold">{{ $trans.get('wizard.step4.transfer-number') }}<span class="font-normal"> IBAN ES38 2100 0920 3802 0026 7119</span></p>
                    <p class="font-bold">BIC:<span class="font-normal"> CAIXESBBXXX</span> </p>
                </div>
                <div>
                    <div class="my-8">
                        <p class="font-bold mt-3">{{$trans.get('wizard.step4.concept')}}</p>
                        <p>{{$trans.get('wizard.step4.concept-text')}}</p>
                    </div>
                    <p class="font-bold mt-3 text-orange">{{$trans.get('wizard.step4.info')}}</p>
                </div>
            </div>
        </transition>
    </div>
</div>
</template>
<script>
export default {
    data() {
        return {
            radio: 'card'
        }
    },
    mounted() {
        this.$store.commit('setSelected', { prop: 'paymentmethod', value: this.radio });
    },
    methods: {
        handleInput (e) {
            this.$store.commit('setSelected', { prop: 'paymentmethod', value: this.radio });
        }
    },
}
</script>
<style lang="scss" scoped>
.payment-selector{
    display:flex;
    flex-direction: column;
    .radio-container{
        padding: 1rem 2rem;
        .mdc-form-field{
            .mdc-radio__background::before{
                // background-color: #4a90e2!important;
            }
            .mdc-radio__outer-circle, .mdc-radio__inner-circle{
                border-color: #4a90e2!important;
            }

            label{
                font-size: 16px;
                font-weight: bold;
            }

        }
    }
    .hr-black{
        border: solid 1px #979797;
        margin: 1rem 0;
    }
    .text-orange{
        color: #e96639;
    }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
</style>
